module.exports = __webpack_public_path__ + "967d96fd3cb5ad35fd663a7ee956fd76.jpg";